<template>
    <main id="modal" class="flexContainers">
        <div id="spinnerLoader" class="flexContainer abs" v-if="loading">
            <Spinner :animation-duration="5000" :size="60" :color="'#41b4e8'" class="loader"></Spinner>
        </div>
        <div class="wishlist">
            <AddList v-if="isDisplayAddList"></AddList>
            <header class="wishlist-header">
                <i class="icon-close" @click="close"></i>
                <h1 class="title">{{ $t("wishlist.title") }}</h1>
                <h3>{{ $t("wishlist.title2") }}</h3>
            </header>
            <main class="wishlist-main">
                <div :key="i" v-for="(list, i) in getLists" class="content-list">
                    <div class="wishlist-name" @click.self="getMode === 'add' ? addToList(list) : displayComponents(i);">
                        {{ list.name }} ({{ getCountComponent(list) }} items)
                    </div>
                    <div class="wishlist-name" v-if="editName && editIndex === i">
                        <input type="text" v-model="editBookName.name" /> <button @click="saveUpdate();">OK</button>
                    </div>
                    <div class="content-btn-export">
                        <img
                            src="../../../static/assets/mod-icon.svg"
                            height="20"
                            width="20"
                            alt=""
                            v-if="getMode !== 'add'"
                            @click.prevent.stop="updateList(list, i);"
                        />
                        <img
                            src="../../../static/assets/delete-icon.svg"
                            height="20"
                            width="20"
                            alt=""
                            v-if="getMode !== 'add'"
                            @click.prevent.stop="deleteList(list);"
                        />
                        <img
                            src="../../../static/assets/download.svg"
                            height="20"
                            width="20"
                            alt=""
                            v-if="getMode === 'export' && getCountComponent(list) > 0"
                            @click="exportPdf(list);"
                        />
                    </div>
                    <div
                        v-if="getMode !== 'add' && list.data && list.data.components && list.data.components.length > 0 && canDisplayComponents === i"
                    >
                        <ul class="content-components">
                            <li :key="component.id" v-for="component in list.data.components" class="content-component">
                                {{ getComponentName(component) }}&#160;&#160;&#160;{{ component.type ? "[ " + component.type + " ]" : "" }}
                                <i class="delete-component" @click="deleteComponent(list, component);"></i>
                            </li>
                        </ul>
                    </div>
                    <div class="content-wishlist-action"></div>
                </div>
            </main>
            <footer class="wishlist-footer">
                <button class="btnExp" @click="addNewList">{{ $t("wishlist.btadd") }}</button>
            </footer>
        </div>
    </main>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import AddList from "./AddList.vue";
import Globals from "../globals.js";
import Vue from "vue";
import httpService from "../service";
import Spinner from "vue-simple-spinner";
import { i18n } from "../../main";
import cacheService from "@/services/cache";

export default {
    // props: {
    //     mode: {default: 'add', type: String}
    // },
    components: {
        AddList,
        Spinner
    },
    data() {
        return {
            canDisplayComponents: -1,
            background: null,
            color: "#FFF",
            loading: false,
            editName: false,
            editBookName: {},
            editIndex: ""
        };
    },
    computed: {
        ...mapGetters({
            getLists: "catalog/wishlist/getLists",
            getToAddList: "catalog/wishlist/getToAddList",
            isDisplayAddList: "catalog/wishlist/isDisplayAddList",
            getMode: "catalog/wishlist/getMode"
        })
    },
    created() {
        let user = cacheService.getRem3rchUser();
        this.background = user.user.brands[0].linksColor;
    },
    mounted() {
        this.searchList();
    },
    methods: {
        ...mapActions({
            searchList: "catalog/wishlist/searchList",
            saveList: "catalog/wishlist/saveList",
            setDisplay: "catalog/wishlist/setDisplay",
            cleanToAddList: "catalog/wishlist/cleanToAddList",
            setDisplayAddList: "catalog/wishlist/setDisplayAddList",
            deleteListAction: "catalog/wishlist/deleteList",
            addComponentsToList: "catalog/wishlist/addComponentsToList",
            deleteComponentToList: "catalog/wishlist/deleteComponentToList"
        }),
        getCountComponent(list) {
            if (!list) return 0;
            let count = 0;
            let cmps = Globals.getValueObject(list, "data.components", []);
            count = cmps.length;
            return count;
        },
        exportPdf(list) {
            this.loading = true;
            httpService.get("/wishlists/" + list.id + "/pdf").then(response => {
                this.loading = false;
                if (response.status === 400) {
                    alert(response.message);
                } else {
                    let url = Globals.getBaseUrl() + response.url;
                    window.open(url);
                }
            });
        },
        getComponentName(component) {
            return Globals.getTranslate(component.name);
        },
        saveUpdate() {
            this.loading = true;
            this.saveList(this.editBookName).then(res => {
                this.loading = false;
                this.editName = false;
            });
        },
        updateList(list, index) {
            this.editName = true;
            this.editBookName = list;
            this.editIndex = index;
        },
        deleteList(list) {
            this.$swal({
                title: "",
                text: this.$t("wishlist.messageAlertDelete"),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#41b4e8",
                confirmButtonText: this.$t("wishlist.btYes"),
                cancelButtonText: this.$t("wishlist.btNo")
            }).then(result => {
                if (result === true) {
                    this.deleteListAction(list);
                }
            });
        },
        deleteComponent(list, component) {
            this.deleteComponentToList({ list: list, component: component });
            this.saveList(list).then(res => {});
        },
        displayComponents(i) {
            this.canDisplayComponents = this.canDisplayComponents === i ? -1 : i;
        },
        close() {
            this.cleanToAddList();
            this.setDisplay(false);
        },
        addToList(list) {
            this.addComponentsToList(list);
            this.saveList(list).then(res => {
                this.close();
                Vue.toast(this.$t("wishlist.addtolistsuccess", { name: "<strong>" + this.getComponentName(this.getToAddList[0]) + "</strong>" }), {
                    id: "my-toast",
                    className: ["my-toast", "toast-warning", "flexContainer", "txtCenter"],
                    horizontalPosition: "right",
                    verticalPosition: "bottom",
                    mode: "queue"
                });
            });
        },
        addNewList() {
            let currentCampaign = parseInt(cacheService.getCurrentCampaignId(), 10);
            let warningText;
            if (i18n.locale === "fr") {
                warningText = "Vous devez sélectionner une campagne pour créer un nouveau book";
            } else if (i18n.locale === "en") {
                warningText = "You need to select a campaign to create a new book";
            }
            if (currentCampaign === 0) {
                this.$swal({
                    text: warningText,
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#41b4e8",
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                }).then(result => {});
            } else {
                this.setDisplayAddList(true);
            }
        }
    }
};
</script>
<style lang="scss">
#spinnerLoader {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10;
    top: 0;
    left: 0;
    border-radius: 3px;
    .loader {
        margin: auto;
    }
}

#modal {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30;
    padding-bottom: 20px;
    top: 0;
    left: 0;
    /*margin: auto;*/

    .wishlist {
        padding: 12px;
        position: absolute;
        left: calc(50% - 250px);
        top: 20px;
        display: flex;
        max-height: 650px;
        flex-direction: column;
        height: 100%;
        width: 500px;
        background-color: #fff;
        margin: 10px;
        .wishlist-header {
            .icon-close {
                position: absolute;
                right: 15px;
                top: 15px;
                height: 28px;
                width: 28px;
                background-image: url("../../assets/croix.png");
                background-size: 100% auto;
                cursor: pointer;
            }
            padding-left: 20px;
            .title {
                font-size: 25px;
                font-weight: bold;
                color: #000;
                font-family: "Oswald", Sans-Serif;
                /*padding: 5px 20px;*/
            }

            h3 {
                font-size: 15px;
            }
        }

        .wishlist-main {
            flex: 1;
            padding: 10px;
            overflow-y: auto;
            position: relative;

            .delete-component {
                position: absolute;
                background-image: url("../../assets/croix.png");
                background-size: 16px;
                right: 10px;
                height: 16px;
                width: 16px;
            }

            .delete-list {
                /*padding-top: 25px;*/
                /*text-align: right;*/
                background-color: transparent;
                border: none;
                color: #fff;
                font-size: 12px;
                margin-right: 5px;
                cursor: pointer;
            }

            .content-components {
                /*padding-top: 20px;*/
                /*padding-bottom: 25px;*/
                padding-left: 20px;
                .content-component {
                    font-size: 12px;
                    position: relative;
                    padding-bottom: 12px;
                }
            }

            .content-btn-export {
                position: absolute;
                right: -5px;
                top: 7px;
                border: none;
                font-size: 10px;
                padding: 2px 10px 2px 10px;
                .btn-exp-wishlist {
                    padding: 5px 20px;
                    font-size: 12px;
                }
            }

            .content-list {
                /*padding: 10px;*/
                padding-top: 10px;
                font-size: 20px;
                border-bottom: 1px solid #c2c2c2;
                cursor: pointer;
                background-color: #f3f3f3;
                margin-top: 10px;
                position: relative;
                .wishlist-name {
                    /*display: inline-block;*/
                    padding-left: 10px;
                    font-size: 18px;
                    font-family: "Oswald", Sans-Serif;
                }

                .content-wishlist-action {
                    background-color: #b30019;
                    color: #ffffff;
                    margin-top: 15px;
                    .content-wishlist-action-btn {
                        text-align: right;
                    }
                }
            }
        }

        .wishlist-footer {
            padding: 10px;

            button {
                width: 100%;
                color: black;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// WishList.vue?8fbfa680